import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container',
    tabs: 'flex gap-2 pb-6 max-md:flex-nowrap max-md:overflow-x-auto max-md:[scrollbar-width:none] md:pb-7.5 max-md:[&::-webkit-scrollbar]:hidden'
  }
});
